"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsLatinValidator = void 0;
exports.isLatin = isLatin;
exports.IsLatin = IsLatin;
const class_validator_1 = require("class-validator");
let IsLatinValidator = class IsLatinValidator {
    validate(input) {
        if (!input) {
            return false;
        }
        return isLatin(input);
    }
    defaultMessage() {
        return "Invalid characters in the input.";
    }
};
exports.IsLatinValidator = IsLatinValidator;
exports.IsLatinValidator = IsLatinValidator = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "is latin" })
], IsLatinValidator);
// checks for latin characters plus few special characters that can often happen
function isLatin(input) {
    return /^[\p{Script=Latin}\d\s_\-.@+,'&/?]*$/u.test(input);
}
function IsLatin(validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: "isLatin",
            target: object.constructor,
            propertyName,
            options: validationOptions,
            validator: IsLatinValidator,
        });
    };
}
//# sourceMappingURL=IsLatinValidator.js.map